import { Route as MessageUsRoute } from "./MessageUs/Route";
import { Route as ReportIssueRoute } from "./ReportIssue/Route";

import { ChatBubbleSVG } from "../../../components/svg/ChatBubbleSVG";
import { FlagSVG } from "../../../components/svg/FlagSVG";

import { createLinksAndRoutes } from "../../../../utils/createLinksAndRoutes";

const list = [
  {
    path: "message-us",
    link: {
      color: "forest-green",
      title: "Message us",
      Icon: ChatBubbleSVG,
    },
    component: MessageUsRoute,
  },
  {
    path: "report-issue",
    link: {
      color: "sp-blue",
      title: "Report an issue",
      Icon: FlagSVG,
    },
    component: ReportIssueRoute,
  },
];

export const { links, routes } = createLinksAndRoutes(list);
